import React from 'react'

import { Grid, Typography } from '@material-ui/core'

import useStyles from './styles'

const InvalidLinkScreen = () => {
  const classes = useStyles()

  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={12} md={8}>
        <Typography color="primary" className={classes.title}>
          Link indisponível
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography color="primary" className={classes.subtitle}>
          Este link expirou ou foi desativado pela empresa. Solicite um novo
          acesso ao responsável pelo portal.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default InvalidLinkScreen
